import { SET_ZEBRA_APPS_VERSION_MAP, SET_ZEBRA_APPS_LIST } from "redux/constants/VersionMap";

const initialState = {
  versionMap: {},
  zebraAppsList: [],
};

const versionMapReducer = (state = initialState, action) => {
  if (action.type === SET_ZEBRA_APPS_VERSION_MAP) {
    const validPayload = action.payload && typeof action.payload === 'object'
      ? action.payload
      : {};
    return {
      ...state,
      versionMap: validPayload, 
    };
  }
  
  if (action.type === SET_ZEBRA_APPS_LIST) {
    return {
      ...state,
      zebraAppsList: Array.isArray(action.payload) ? action.payload : [],
    };
  }
  
  return state;
};

export default versionMapReducer;